import { useTranslation } from "react-i18next";
import ResponsiveSheet from "@Components/ResponsiveSheet/ResponsiveSheet";
import { useJourneyDynamicDetails } from "../../context";
import PaymentChip from "../PaymentChip/PaymentChip";
import SSRBreakdownContent from "./components/SSRBreakdownContent";
import { transformPassengersToSegments, hasAnySSR, buildAddOnSummaryFromSegments } from "./utils";

export default function SSRBreakdown() {
  const { t } = useTranslation();
  const { passengersState } = useJourneyDynamicDetails();
  const [passengers] = passengersState;

  const segments = transformPassengersToSegments(passengers);
  if (!hasAnySSR(segments)) return null;

  const addOnRows = buildAddOnSummaryFromSegments(segments);
  const currency = addOnRows[0]?.currency ?? "";

  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="text-base text-font-default font-semibold">{t("Flights.details.summary.addonsBreakdown")}</div>
      <ResponsiveSheet
        label={t("Flights.details.summary.selectedAddons")}
        renderTrigger={({ open }) => (
          <PaymentChip rows={addOnRows} title={t("Flights.details.summary.selectedAddons")} currency={currency} onClick={open} />
        )}
        renderSheet={() => <SSRBreakdownContent segments={segments} addOnRows={addOnRows} />}
      />
    </div>
  );
}
